var cancel_button = ( function( $ ) {

	var $button;

	var _init = function() {
		$button = $( '.cancel-booking-button' );
		$button.on( 'click', _show_popup );
	};

	var _show_popup = function( e ) {
		e.preventDefault();

		var $cancel_button = $( this );
		var event_name     = $cancel_button.closest( '.booking-card' ).children( '.event-title' ).children( 'a' ).text();
		var can_cancel     = $cancel_button.data( 'can-cancel-booking' );
		var popup          = _get_popup( event_name, can_cancel );
		var $body          = $( 'body' );

		$body.append( popup );
		$body.addClass( 'popup-open' );

		var $popup_overlay = $( '.crate-popup-overlay' );
		// noinspection JSJQueryEfficiency
		var $popup         = $( '.exit-popup' );

		$popup_overlay.fadeIn();
		$popup.fadeIn();
		$popup.addClass( 'open' );

		$popup_overlay.on( 'click', _close_popup );
		$popup.find( 'a.close-popup' ).on( 'click', _close_popup );
		$popup.find( 'a.cancel-booking' ).on( 'click', _close_popup );

		// Cancel booking
		$popup.find( 'a.continue-booking' ).on( 'click', function( e ) {
			e.preventDefault();
			_call_ajax( $cancel_button );
			_close_popup( e );
			window.location.href = $( this ).attr( 'href' );
		} );
	};

	var _close_popup = function( e ) {
		e.preventDefault();

		$( 'body' ).removeClass( 'popup-open' );

		var $popup         = $( '.exit-popup' );
		var $popup_overlay = $( '.crate-popup-overlay' );

		$popup.fadeOut( 400 );
		$popup_overlay.fadeOut( 400 );

		setTimeout( function() {
			$popup.remove();
			$popup_overlay.remove();
		}, 400 );
	};

	var _get_popup = function( event_name, can_cancel ) {
		var popup = '<div class="crate-popup-overlay"></div>';

		var actions = '';
		var text    = '';

		if ( can_cancel == "1" ) {
			actions = '<a href="#" class=" cancel-booking">Return To My Account</a>' +
				'<a href="#" class="button continue-booking">Cancel Booking</a>';
			text    = 'You are about to cancel your booking for ' + event_name + '. Are you sure you want to continue?'
		} else {
			text = 'Unfortunately you are unable to cancel this booking online. Please contact the Training Hub team on <a href="mailto:candptraininghub@nhs.net">candptraininghub@nhs.net</a> to assist you with this.'
		}

		popup += '<div class="exit-popup">' +
			'<a href="#" class="close-popup">&times;</a>' +
			'<div class="popup-inner">' +
			'<div class="heading">Would you like to cancel your booking?</div>' +
			'<div class="copy">' + text + '</div>' +
			'<div class="actions">' + actions + '</div>' +
			'</div>';

		return popup;
	};

	var _call_ajax = function( $cancel_button ) {
		var post_id = $cancel_button.data( 'id' );

		$.post( ScriptData.ajaxurl, {
			action: 'crate_cancel_booking',
			nonce: ScriptData.cancel_booking_nonce,
			post_id: post_id
		}, response => _on_success( response, $cancel_button ) ).fail( ( jqXHR, textStatus, errorThrown ) => _on_failure() );
	};

	var _on_success = function( response, $cancel_button ) {
		if ( !response.success ) {
			_on_failure( response.message );
			return;
		}

		$cancel_button.parents( '.booking-card' ).addClass( 'hidden' );

		$( '.response-message' ).removeClass( 'hidden' ).removeClass( 'failure' ).addClass( 'success' ).text( 'Your booking has successfully been cancelled. ' );
	}

	var _on_failure = function( error_message ) {
		var $response_message = $( '.response-message' );

		$response_message.removeClass( 'hidden' ).removeClass( 'success' ).addClass( 'failure' );

		if ( error_message ) {
			$response_message.text( error_message );
		} else {
			$response_message.text( 'There was an error while cancelling your booking. Please refresh and try again.' )
		}
	};

	if ( $( '.cancel-booking-button' ).length > 0 ) {
		_init();
	}

} )( jQuery );

module.exports = cancel_button;